export default class AreasOfExpertise {


	// Constructor
	constructor(asscroll, element) {
		this.asscroll = asscroll;
		this.element = element;

		this.container = this.element.querySelector('.section-areas-of-expertise--scroll');
		this.fixed = this.element.querySelector('.section-areas-of-expertise--fixed');
		this.images = Array.prototype.slice.call(this.element.querySelectorAll('.section-areas-of-expertise--img'), 0);
		this.items = Array.prototype.slice.call(this.element.querySelectorAll('.section-areas-of-expertise--item'), 0)
		this.itemsContainer = this.element.querySelector('.section-areas-of-expertise--items');
		this.link = this.element.querySelector('.section-areas-of-expertise--link');
		this.textContainer = this.element.querySelector('.section-areas-of-expertise--text');

		this.scroll = this.scroll.bind(this);
	}


	// Public Methods
	destroy() {
		this.disable();
		delete this.asscroll;
		delete this.container;
		delete this.element;
		delete this.fixed;
		delete this.images;
		delete this.items;
		delete this.itemsContainer;
		delete this.link;
		delete this.textContainer;
	}
	enable() {
		this.asscroll.on('update', this.scroll);
	}
	disable() {
		this.asscroll.off('update', this.scroll);
	}


	// Private Methods
	updateBgColor() {
		const { top } = this.element.getBoundingClientRect();
		const elementHeight = this.element.offsetHeight;
		const windowHeight = window.innerHeight;
		const height = windowHeight - elementHeight;
		const offset = (window.innerWidth < 768) ? windowHeight * 0.5 : windowHeight * 0.3;
		if (top <= height - offset) {
			document.body.classList.remove('bg-areas-of-expertise');
		} else if (top - offset <= 0) {
			document.body.classList.add('bg-areas-of-expertise');
		} else {
			document.body.classList.remove('bg-areas-of-expertise');
		}
	}


	// Event Handlers
	scroll({ currentPos }) {
		this.updateBgColor();
		const { top } = this.container.getBoundingClientRect();
		const elementHeight = this.container.offsetHeight;
		const windowHeight = window.innerHeight;
		const windowWidth = window.innerWidth;
		const height = windowHeight - elementHeight;
		const percent = Math.min(1, Math.max(0, top / height));

		const steps = this.images.length - 1;
		const step = Math.round(steps * percent);

		this.images.forEach((item, index) => {
			if (index === step) {
				item.classList.add('is-active');
			} else {
				item.classList.remove('is-active');
			}
		});
		this.items.forEach((item, index) => {
			if (index === step) {
				item.classList.add('is-active');
			} else {
				item.classList.remove('is-active');
			}
			if (index === step - 1 || index === step + 1) {
				item.classList.add('is-1-from-active');
			} else {
				item.classList.remove('is-1-from-active');
			}
			if (index === step - 2 || index === step + 2) {
				item.classList.add('is-2-from-active');
			} else {
				item.classList.remove('is-2-from-active');
			}
		});

		if (step === steps) {
			this.link.classList.add('is-active');
		} else {
			this.link.classList.remove('is-active');
		}

		const itemsContainerHeight = this.itemsContainer.offsetHeight;
		if (windowWidth >= 768) {
			const itemsContainerY = (itemsContainerHeight / steps) * (steps * -percent);
			this.itemsContainer.removeAttribute('style');
			this.textContainer.style.transform = `translate3d(0, ${itemsContainerY + (windowHeight * 0.5)}px, 0)`;
		} else {
			const itemsContainerY = (itemsContainerHeight / (steps + 1)) * (steps * -percent);
			this.itemsContainer.style.transform = `translate3d(0, ${itemsContainerY}px, 0)`;
			this.textContainer.removeAttribute('style');
		}

		if (top <= height) {
			this.element.classList.add('is-bottom');
			this.element.classList.remove('is-sticky');
			this.fixed.style.transform = 'translate3d(0, 0, 0)';
		} else if (top <= 0) {
			this.element.classList.remove('is-bottom');
			this.element.classList.add('is-sticky');
			this.fixed.style.transform = `translate3d(0, ${currentPos}px, 0)`;
		} else {
			this.element.classList.remove('is-bottom');
			this.element.classList.remove('is-sticky');
			this.fixed.style.transform = 'translate3d(0, 0, 0)';
		}

	}


}
